import type { LayerRaw } from '@tsyl/karonte/lib/types/layers'

export default {
  id: 'Predictive Service Areas',
  type: 'WMS',
  url: '/wfas-proxy/geoserver/wfas/wms',
  title: {
    'en-US': 'Predictive Service Areas',
    'pt-BR': 'Áreas de serviço preditivo',
    'es-ES': 'Áreas de servicio predictivo',
    'fr-FR': 'Zones de service prédictif'
  },
  zindex: 1, // TODO: CHECK
  active: false,
  activeTarget: 'visibility',
  customProperties: { group: 'reference' },
  legend: {
    title: 'n/a'
  },
  sublayers: [
    {
      id: 'PSA_Boundaries',
      visible: true,
      layers: 'PSA_Boundaries',
      legend: {
        title: {
          'en-US': 'Predictive Service Areas',
          'pt-BR': 'Áreas de serviço preditivo',
          'es-ES': 'Áreas de servicio predictivo',
          'fr-FR': 'Zones de service prédictif'
        },
        items: [
          {
            text: {
              'en-US': 'Predictive Service Areas',
              'pt-BR': 'Áreas de serviço preditivo',
              'es-ES': 'Áreas de servicio predictivo',
              'fr-FR': 'Zones de service prédictif'
            },
            color: '#ffa723',
            icon: 'mdi-minus'
          }
        ]
      }
    }
  ],
  icon: 'mdi-barley' // TODO: CHECK
} as LayerRaw
